import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Firm-side display name for a client. Always returns the LEGAL name
// (`name`) — the alias is used only for email salutations / addressee
// wording, never for the client heading or the clients list. Falls back
// to the alias only if a legal name isn't captured yet.
export function clientDisplayName(c) {
  if (!c) return "";
  const name = (c.name || "").trim();
  return name || c.alias || "";
}
